import VAChatRestartOverlayTemplate from '../../templates/dialog_overlays/RDTheme/VAChatRestartOverlay.ejs';
import VAChatRestartOverlayRDPlusThemeTemplate from '../../templates/dialog_overlays/RDPlusTheme/VAChatRestartOverlay.ejs';

const ImportRestartChatOverlayFactory = () => {
    if (ApexChat.IsRoundedDynamicPlusTheme) {
        return {
            VAChatRestartOverlayTemplate: VAChatRestartOverlayRDPlusThemeTemplate
        };
    }
    return {
        VAChatRestartOverlayTemplate
    };
};
export default ImportRestartChatOverlayFactory;
